import { BREAKPOINTS } from '~/theme/constants';

export const checkIsSmallScreen = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth <= BREAKPOINTS.sm;
  }

  return false;
};
